import React from 'react';
import classNames from 'classnames/bind';
import styles from './logo.module.pcss';

import Icon from '../Icon';
import { redirect } from '../../utils/cartUtils';
import { getColor } from '../../utils/style';
import { gtmEventPush } from '../../../modules/ga/GTMdatalayer';
import { readCookie } from '../../../components/common/Cookie';
import { replaceWithJioCDN } from '../../../utils/imageHandling';

interface LogoProps {
  logoClass?: string;
  pageTitle?: string;
  isSis?: boolean;
  sisStyles: Record<string, string | undefined>;
}

const cx = classNames.bind(styles);

const getLogoIcon = (
  isSis: boolean | undefined,
  sisStyles: Record<string, string | undefined>
): JSX.Element => {
  if (!isSis) {
    return <Icon icon="icon-AJIO_Logo" ariaLabel='ajio logo'/>;
  }
  const { smallerLogo, subdomain } = sisStyles;
  return (
    <a href={`http://${subdomain}`}>
      <img className={cx('ajioLogo_image')} src={replaceWithJioCDN(smallerLogo)} alt="logo" />
    </a>
  );
};

const logoClick = (): JSX.Element => {
  let userType = readCookie('U') || 'anonymous';
  gtmEventPush({
    event: 'logo_click',
    referral_page: window.location.href,
    logo_position: 'Top header',
    page_url: window.location.href,
    user_type: userType === 'anonymous' ? 'notLoggedIn' : 'loggedIn'
  });
  redirect('/');
};

const Logo = ({ logoClass, pageTitle, isSis, sisStyles = {} }: LogoProps): JSX.Element => {
  const { textColor = '' } = sisStyles;
  const isHomePage = window.location.pathname === '/';
  const headerlogocolor = isSis ? textColor : '#202020';
  return (
    <div className={cx('ajioLogo', logoClass)} role="presentation" onClick={logoClick}>
      {isHomePage ? (
        getLogoIcon(isSis, sisStyles)
      ) : (
        <span
          className={cx('logoHeading', 'is-capitalized')}
          style={getColor({ color: headerlogocolor })}
        >
          {pageTitle}
        </span>
      )}
    </div>
  );
};

Logo.defaultProps = {
  logoClass: '',
  pageTitle: 'AJIO',
  isSis: false
};

export default Logo;
